import { EnvironmentVariables } from './environment-variables';

export const environment: EnvironmentVariables = {
  PIPELINE_STAGE: 'prod',
  TESTBED_BASE_URL: 'https://testbed.processpuzzle.de',
};
